import React, { useEffect, useState } from "react";
import { Row, Col, Nav, Tab } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import lightLogo from "../../../../img/logo-light.png";
import LoadingView from "../loading-view";
import FailedView from "../failed-view";
import SuccessView from "../success-view";
import RegisterView from "../register-view";
import FetchInvitationLoader from "../dashboard-invitation-loader";
import { ToastContainer } from "react-toastify";
import * as EmailValidator from "email-validator";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "../../../../networking/firebase";
import { requestInvitationValidation } from "../../../../redux/actions/invitation";
import { setFallbackMessage } from "../../../../redux/actions/universal";
import { sendErrorNotification } from "../../../universal/notifications/notifications";
import {
  requestCanRegister,
  requestInvitationRegistration,
} from "../../../../redux/actions/registration";
import { retrieveUserDetails } from "../../../../redux/actions/user";

import "react-toastify/dist/ReactToastify.css";
import "./style.scss";

const Index = (props) => {
  const dispatch = useDispatch();

  const [checkRegister, setCheckRegister] = useState(false);
  const currentUser = auth.currentUser && auth.currentUser.uid;

  const invitationId =
    props && props.match && props.match.params && props.match.params.id;

  const [view, setView] = useState("register");
  const [termsChecked, setTermsChecked] = useState(false);

  const checkCanRegisterLoading = useSelector(
    (state) => state.registration.checkCanRegister.loading
  );
  const checkCanRegisterError = useSelector(
    (state) => state.registration.checkCanRegister.error
  );
  const checkCanRegisterStatus = useSelector(
    (state) => state.registration.checkCanRegister.status
  );

  const validationStatus = useSelector(
    (state) => state.invitation.validationStatus
  );
  const validationLoading = useSelector(
    (state) => state.invitation.validationLoading
  );
  const validationError = useSelector(
    (state) => state.invitation.validationError
  );
  const invitationDetails = useSelector(
    (state) => state.invitation.invitationDetails
  );

  const validateInviteRegisterStatus = useSelector(
    (state) => state.registration.validateInviteRegister.status
  );
  const validateInviteRegisterLoading = useSelector(
    (state) => state.registration.validateInviteRegister.loading
  );
  const validateInviteRegisterError = useSelector(
    (state) => state.registration.validateInviteRegister.error
  );

  const [tabs, setTabs] = useState([
    {
      name: "Kontodetaljer",
      description: "Kort om deg selv",
      icon: <i class="fas fa-user"></i>,
      active: true,
    },
    {
      name: "Kom i gang",
      description: "Gå til dashboard",
      icon: <i class="fad fa-check-double"></i>,
      active: false,
    },
  ]);

  const [organizationNumber, setOrganizationNumber] = useState("");

  const [userObject, setUserObject] = useState({
    firstName: null,
    lastName: null,
    email: null,
    mobile: null,
    password: null,
  });

  const updateActiveTab = (num) => {
    if (num === 0) {
      const newTabs = [...tabs];
      newTabs[0].active = true;
      newTabs[1].active = false;
      setTabs(newTabs);
    } else if (num === 1) {
      const newTabs = [...tabs];
      newTabs[0].active = false;
      newTabs[1].active = true;
      setTabs(newTabs);
    }
  };

  useEffect(() => {
    if (currentUser && !checkRegister) {
      dispatch(requestCanRegister(currentUser));
      setCheckRegister(true);
    } else {
      setCheckRegister(true);
      if (invitationId) {
        dispatch(requestInvitationValidation({ id: invitationId }));
      } else {
        props.history.push("/");
      }
    }
  }, [invitationId, checkRegister, currentUser]);

  useEffect(() => {
    if (checkRegister && validationStatus && validationStatus === "success") {
      if (invitationDetails.email && invitationDetails.organizationNumber) {
        setUserObject({ ...userObject, email: invitationDetails.email });
        setOrganizationNumber(invitationDetails.organizationNumber);
      }
    }

    if (validationError) {
      dispatch(
        setFallbackMessage({
          type: "error",
          content: "Invitasjonen du oppga er ugyldig.",
        })
      );
      props.history.push("/");
    }
  }, [validationStatus, validationError]);

  useEffect(() => {
    if (
      !checkCanRegisterLoading &&
      !checkCanRegisterStatus &&
      checkCanRegisterError &&
      !validateInviteRegisterLoading
    ) {
      props.history.push("/dashboard/oversikt");
    }
  }, [checkCanRegisterStatus, checkCanRegisterLoading, checkCanRegisterError]);

  useEffect(() => {
    if (
      !validateInviteRegisterLoading &&
      !validateInviteRegisterError &&
      validateInviteRegisterStatus === "success"
    ) {
      dispatch(retrieveUserDetails(auth?.currentUser?.uid));
      updateActiveTab(1);
      setView("success");
    }
  }, [
    validateInviteRegisterError,
    validateInviteRegisterStatus,
    validateInviteRegisterLoading,
  ]);

  useEffect(() => {
    if (
      !validateInviteRegisterLoading &&
      validateInviteRegisterError &&
      !validateInviteRegisterStatus
    ) {
      setView("failed");
    }
  }, [
    validateInviteRegisterError,
    validateInviteRegisterStatus,
    validateInviteRegisterLoading,
  ]);

  const clickRegister = async () => {
    try {
      const trimmedObject = userObject;
      trimmedObject["mobile"] = parseInt(
        userObject["mobile"].toString().replace(/ /g, "")
      );
      if (
        organizationNumber &&
        trimmedObject.firstName &&
        trimmedObject.lastName &&
        trimmedObject.email &&
        trimmedObject.mobile &&
        trimmedObject.password
      ) {
        if (EmailValidator.validate(trimmedObject.email)) {
          if (termsChecked) {
            setView("loading");
            dispatch(
              requestInvitationRegistration({
                user: trimmedObject,
                invitation: invitationId,
                type: "default",
                organizationNumber: parseInt(
                  organizationNumber.toString().replace(/ /g, "")
                ),
              })
            );
          } else {
            sendErrorNotification("Du må akseptere vilkårene.");
          }
        } else {
          sendErrorNotification("Ugyldig e-postaddresse.");
        }
      }
    } catch (e) {
      sendErrorNotification("Kunne ikke fullføre registrering.");
    }
  };

  const determineViewRender = () => {
    switch (view) {
      case "register":
        if (!validateInviteRegisterLoading) {
          return (
            <RegisterView
              organizationNumber={organizationNumber}
              userObject={userObject}
              setUserObject={setUserObject}
              validateInviteRegisterLoading={validateInviteRegisterLoading}
              clickRegister={clickRegister}
              termsChecked={termsChecked}
              setTermsChecked={setTermsChecked}
            />
          );
        }
        break;
      case "failed":
        return <FailedView />;
      case "success":
        return <SuccessView />;
    }
    return <LoadingView />;
  };

  const determinePreloading = () => {
    if (
      validationLoading &&
      !invitationDetails.email &&
      !invitationDetails.organizationNumber
    ) {
      return <FetchInvitationLoader />;
    } else if (checkCanRegisterLoading && !validateInviteRegisterLoading) {
      return <FetchInvitationLoader />;
    }
  };

  return (
    <section className="invitation-page-section">
      <div className="inner-invitation-page-container">
        <div className="full-content-container">
          <div className="invitation-display-container">
            <div className="invitation-box-container">
              <div className="inner-invitation-box-container">
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row className="invitation-row">
                    <Col className="menu-col">
                      <Link to="/">
                        <img
                          alt="Leadfind logo"
                          className="menu-logo"
                          src={lightLogo}
                        />
                      </Link>
                      <h3 className="invitation-title">Opprett ny konto</h3>
                      <p className="invitation-description">
                        Det går fortere enn du tror, registrering tar under ett
                        minutt.
                      </p>
                      <Nav
                        variant="pills"
                        className="flex-column menu-navigation"
                      >
                        {tabs.map((tab) => {
                          return (
                            <Nav.Item>
                              <Nav.Link active={tab.active}>
                                <div
                                  className={`single-step-container ${
                                    tab.active ? "active" : ""
                                  }`}
                                >
                                  <Row className="step-row">
                                    <Col className="icon-col my-auto">
                                      <div className="step-container">
                                        <span className="icon">{tab.icon}</span>
                                      </div>
                                    </Col>
                                    <Col className="data-col my-auto">
                                      <span className="step-title">
                                        {tab.name}
                                      </span>
                                      <span className="step-description">
                                        {tab.description}
                                      </span>
                                    </Col>
                                  </Row>
                                  <span className="active-indicator" />
                                </div>
                              </Nav.Link>
                            </Nav.Item>
                          );
                        })}
                      </Nav>
                    </Col>
                    <Col className="display-col">
                      {determinePreloading()}
                      <div className="inner-tab-container">
                        {determineViewRender()}
                      </div>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
            <div className="links-container">
              <Link to="/">Leadfind.no</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/personvern">Personvern</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/cookies">Cookies</Link>
              <span className="circle-separator">
                <i class="fas fa-circle"></i>
              </span>
              <Link to="/vilkår">Vilkår</Link>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default withRouter(Index);
